import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import MenuBar from "./MenuBar";
import poshBkg from "../../assets/img/posh-bg.webp";
import { useContext } from "react";
import { DataContext } from "../../context/data-context";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";

/** ========================================================================
 * * Layout Component
 * Renders the side bar and the main content container side by side.
 * ========================================================================== */

export default function Layout({ children }) {
  const { loadingData, admin } = useContext(DataContext);

  return (
    <div className="bg-gradient-to-br from-stone-900">
      <div className="lg:h-screen">
        <img
          className="fixed top-0 left-0 object-cover w-screen h-screen -z-10"
          src={poshBkg}
        />
        <Navbar />
        <MenuBar />
        <div className="grid gap-4 mx-2 lg:gap-2 md:grid-cols-6">
          <Sidebar />
          <div className="md:col-span-5">
            {(loadingData || !admin.active ) ? <LoadingSpinnerWrapper /> : children}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
